import React from "react"
import PropTypes from "prop-types"

import {H4} from "@irati/ui/src/Typography/Heading"
import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {recognitionUsersToStringTitle, recognitionUsersToStringSubtitle} from "@irati/recognition/utils/recognitionUsersToString"

import {Bold} from "../styled/Card"

const Recognition = ({recognition, formatMessage}) => {
  const isEveryone = recognition.isEveryone
  const user = recognition.createdBy || authentication.user()
  const createdBy = recognition?.senderName || firstnameLastname(user)
  if (isEveryone) {
    return (
      <H4>
        <Bold>
          <FormattedMessage
            id="recognition.lbl.everyone.title"
            values={{businessName: authentication.business().businessName, author: createdBy}}
          />
        </Bold>
      </H4>
    )
  }
  const receivers = recognition.receivers.results
  const title = recognitionUsersToStringTitle(receivers, formatMessage)
  const subTitle = recognitionUsersToStringSubtitle(receivers, createdBy, formatMessage)

  return (
    <H4>
      <Bold>{title}</Bold>
      {subTitle}
    </H4>
  )
}

Recognition.propTypes = {
  recognition: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
}

export default injectIntl(Recognition)
